<template>
    <div class="calculator p-4 position-relative">
        <h4>Padding calculator
            <button class="btn btn-danger" @click="$emit('close')">x</button>
        </h4>
        <div class="form-group">
            <label for="width">Width:</label>
            <input type="number" id="width" v-model.number="calc.width">
        </div>
        <div class="form-group">
            <label for="height">Height:</label>
            <input type="number" id="height" v-model.number="calc.height">
        </div>
        <div class="form-group">
            <label for="percentage">Percentage:</label>
            <input type="number" id="percentage" v-model.number="calc.percentage">
        </div>
        <p>Result {{calcResult}} %</p>
    </div>
</template>

<script type="text/babel">

export default {
    name: 'Calculator',
    data () {
        return {
            calc: {
                width: 0,
                height: 0,
                percentage: 0
            }
        };
    },
    computed: {
        calcResult () {
            return ((this.calc.percentage / 100) * (this.calc.height / this.calc.width)) * 100;
        }
    }
};

</script>
